import seliseLogo from '/Logo.svg';
import { cn } from '@/lib/utils';

type LoginSeliseLogoProps = {
  className?: string;
  variant?: 'default' | 'hero';
};

export const LoginSeliseLogo = ({ className, variant = 'default' }: LoginSeliseLogoProps) => {
  return (
    <img
      src={seliseLogo}
      alt="SELISE campaigns"
      className={cn(
        'h-10 w-[5.8125rem] shrink-0 object-contain object-left',
        variant === 'hero' && 'relative z-10',
        className
      )}
    />
  );
};
